import { render, staticRenderFns } from "./RelatedLinksForm.vue?vue&type=template&id=51120bca&"
import script from "./RelatedLinksForm.vue?vue&type=script&lang=js&"
export * from "./RelatedLinksForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports